import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DEPOT_DECENNALE',
  title: 'Presentare il certificato decennale alla data di apertura del cantiere',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: `Il file della vostra impresa non è aggiornato?
    Potrebbe essere che il tuo certificato decennale alla data della dichiarazione di apertura del cantiere per questa operazione non è aggiornato...
    Ecco come assicurarsene in 4 passi...`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Individuare la data del DOC sulla vostra operazione'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DECENNALE/IT_DEPOT_DECENNALE_1.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Trova la tua impresa nell\'organigramma dell\'operazione'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DECENNALE/IT_DEPOT_DECENNALE_2.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Visualizza i tuoi documenti'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Clicca sui 3 puntini:'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DECENNALE/IT_DEPOT_DECENNALE_3.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Poi su Mostra documenti:'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DECENNALE/IT_DEPOT_DECENNALE_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Presenti il suo certificato decennale'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Trova il certificato decennale mancante nell\'elenco dei documenti e clicca su File:'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DECENNALE/IT_DEPOT_DECENNALE_5.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Presentare il certificato decennale per la data di apertura'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DECENNALE/IT_DEPOT_DECENNALE_6.jpg`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: ''
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: ''
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'I vostri documenti saranno verificati e trattati entro 48 ore.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: ''
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Puoi controllare lo stato di tutti i tuoi documenti dalla scheda Documenti:'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DECENNALE/IT_DEPOT_DECENNALE_7.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: ''
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Puoi anche rilasciare il tuo Certificato Decennale alla data del DOC da questa scheda, cliccando su «Aggiungere una nuova versione»:'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DECENNALE/IT_DEPOT_DECENNALE_8.png`
  }]
};
